module.exports = __webpack_public_path__ + "static/nordic_3-a9b0424e3647fa94e8a6291ddf90285d.jpg";